import { render } from "./Problem.vue?vue&type=template&id=54f30ef0&scoped=true&ts=true"
import script from "./Problem.vue?vue&type=script&lang=ts"
export * from "./Problem.vue?vue&type=script&lang=ts"

import "./Problem.vue?vue&type=style&index=0&id=54f30ef0&lang=scss&scoped=true"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54f30ef0"]])

export default __exports__